import React from 'react'
import { useTranslation } from 'react-i18next'
import { BeWizrMediaItem } from '~/models'
import { memo } from '~/ui/component'
import { TextBlock } from '~/ui/components'
import BeWizrTile from '../../bewizr/BeWizrTile'
import { register } from './registry'

export interface Props {
  item: BeWizrMediaItem
}

const BeWizrMediaLibraryItem = memo('BeWizrMediaLibraryItem', (props: Props) => {

  const {item} = props
  const image = item.links.image ?? item.images[0] ?? null

  const [t] = useTranslation('bewizr-misc-items')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrTile
        label={t('bewizr-library:item-types.mediaitem')}
        title={item.title}
        icon='image'
        image={image}
        href={`/bewizr-misc-items/media/-/${item.id}`}
        buttonCaption={t('media.view')}
        horizontal
      >
        {item.shortDescription && (
          <TextBlock dim small>
            {item.shortDescription}
          </TextBlock>
        )}
      </BeWizrTile>
    )
  }

  return render()

})

register('mediaitem', BeWizrMediaLibraryItem)